import { LoyaltyGiftReservationService } from 'app/services/loyalty/loyalty-gift-reservation.service';
import { Router } from '@angular/router';
import { CalendarTranslateService } from './../../../modules/UIKit/services/calendarTranslate.service';
import { CommonService } from './../../../services/utils/common.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { LoyaltyReservationSearchService } from 'app/services/loyalty/loyalty-reservation-search.service';
import { LoyaltyReservationSearchAllService } from 'app/services/loyalty/loyalty-reservation-search-all.service';
import { SelectItem } from 'primeng/api';
import * as moment from 'moment';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-loyalty-reservation-search',
  templateUrl: './loyalty-reservation-search.component.html',
  styleUrls: ['./loyalty-reservation-search.component.css']
})
export class LoyaltyReservationSearchComponent implements OnInit {

  paginationType = KontableComponent.ServerPagination;
  customFilter = KontableComponent.CustomFilter;
  selectFilter = KontableComponent.SelectFilter;
  dateFilter = KontableComponent.DateFilter;
  giftType: SelectItem[] = [];
  deliveryType: SelectItem[] = [];
  status: SelectItem[] = [];
  dialog: boolean = false;
  tempId: number;
  modalTitle = '';
  labels = {};
  record = {};
  // Extended Search
  extSearchResult: any;
  totalRecords = 0;
  showAllReservations = false;
  service: any;
  maxChars: number;
  activeCatalog: SelectItem[] = [{value:'0',label:'Attivo'},{ value:'1', label:'Tutti'}];
  initialFilters = [];
  @ViewChild('table') table: any;

  constructor(
    public reservationSearchService: LoyaltyReservationSearchService,
    public reservationSearchAllService: LoyaltyReservationSearchAllService,
    private translate: TranslateService,
    private commonService: CommonService,
    public calendarTranslateService: CalendarTranslateService,
    private router: Router,
    private giftService: LoyaltyGiftReservationService
  ) {
    this.service = this.reservationSearchService;
    this.maxChars = +sessionStorage.getItem('cardsLength');
  }

  ngOnInit() {
    this.getGiftType();
    this.getDeliveryType();
    this.getStatusDefinition();
    this.initialFilters.push({key: "catalog_description", value: '0'});
    this.translate.get([
      'reservations.infoReservation',
      'common.all'
    ]).subscribe((res) => {
      this.labels['infoReservation'] = res['reservations.infoReservation'];
      const all = {value: null, label: res['common.all']};
      this.giftType.push(all);
      this.deliveryType.push(all);
      this.status.push(all);
    });
  }

  /**
   * Metodo per recuperare i gift type, che vengono inseriti nel dropdown di ricerca
   */
  getGiftType(){
    //Popolo il dropdown dei gift type
    this.reservationSearchService.getGiftType().subscribe(el => {
      el.forEach(el => this.giftType.push({ value: el.description, label: el.description }))
    });
  }

  /**
   * Metodo per recuperare i delivery type, che vengono inseriti nel dropdown di ricerca
   */
  getDeliveryType(){
    //Popolo dropdown dei delivery type
    this.reservationSearchService.getDeliveryType().subscribe(el => {
    el.forEach(el => { this.deliveryType.push({ value: el.description, label: el.description })
      })
    });
  }

  /**
   * Metodo per recuperare gli status definition, che vengono inseriti nel dropdown di ricerca
   */
  getStatusDefinition(){
    this.reservationSearchService.getStatusDefinition().subscribe(el => {
      el.forEach(el => { this.status.push({ value: el.description, label: el.description })
      });
    })
  }

  /**
   * Metodo per la visualizzazione del pop-up con le informazioni dettagliate del record in cui si preme il button
   * @param event
   */
  showDetail(event){
    sessionStorage.setItem('customerFullName', `${event.customer_name} ${event.customer_surname}`);
    sessionStorage.setItem('email', event.email);
    sessionStorage.setItem('telephone', event.telephone);
    this.tempId = event.id;
    this.modalTitle = this.labels['infoReservation'];
    this.record = event;
    this.dialog = true;
  }

  /**
   * Metodo che chiude il pop-up di dettaglio
   */
  closeDialog(){
    this.dialog = false;
    sessionStorage.removeItem('customerFullName');
    sessionStorage.removeItem('email');
    sessionStorage.removeItem('telephone');
    sessionStorage.removeItem('customer');
    sessionStorage.removeItem('acmCode');
    sessionStorage.removeItem('acmDescription');
    sessionStorage.removeItem('cardNo');
  }

  /**
   * Porta alla lista delle prenotazioni del cliente,
   * attive o chiuse a seconda dello stato della prenotazione selezionata
   */
  goToCustomerReservations(reservation) {
    sessionStorage.setItem('customer', `${reservation.customer_code} - ${reservation.customer_name} ${reservation.customer_surname}`);
    sessionStorage.setItem('acmCode', reservation.acm_code);
    sessionStorage.setItem('acmDescription', reservation.acm_description);
    sessionStorage.setItem('cardNo', reservation.card_no);
    this.giftService.search = true;
    const reservationStatus = reservation.status.toUpperCase();
    if (reservationStatus === 'CONFERMATO' || reservationStatus === 'ANNULLATO' || reservationStatus === 'RITIRATO') {
      this.router.navigate([`loyalty/reservations/${reservation.customer_id}/${reservation.card_id}/${reservation.acm_id}/closed`]);
    } else {
      this.router.navigate([`loyalty/reservations/${reservation.customer_id}/${reservation.card_id}/${reservation.acm_id}/active`]);
    }
  }

  /**
   * Scatena i filtri della Extended Search
   */
  sendExtSearchQuery(event, all = false) {
    /*
      Azzero totalRecords perchè, in caso di svuotamento della table e successiva
      ripetizione della medesima ricerca, il valore non risulterebbe aggiornato e,
      di conseguenza, causerebbe errori di paginazione
    */
    this.totalRecords = 0;
    const params = {query: event.query, offset: event.offset, limit: event.limit};
    if (event.sortField && event.sortDir) {
      Object.assign(params, {sortField: event.sortField, sortDir: event.sortDir});
    }
    if (all) {
      this.reservationSearchAllService.sendExtSearchQuery(params).subscribe(res => {
        this.extSearchResult = res.data;
        this.totalRecords = res.metadata.total;
      });
    } else {
      this.reservationSearchService.sendExtSearchQuery(params).subscribe(res => {
        this.extSearchResult = res.data;
        this.totalRecords = res.metadata.total;
      });
    }
  }

  getReservations(all: boolean) {
    this.table.clearFilters();
    this.service = all ? this.reservationSearchAllService : this.reservationSearchService;
    this.showAllReservations = all;
  }

  downloadExcel(filters, all = false) {
    this.reservationSearchService.getExcelFilename(all, filters).subscribe(
      filename => {
        this.reservationSearchService.downloadExcel(filename).subscribe(res => {
          FileSaver.saveAs(res, filename);
        })
      },
      error => console.error(error)
    );
  }


}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-reservation-search/loyalty-reservation-search.component.ts